import { NetworkStatus } from "@apollo/client";
import { AIAssessmentsList, AssessmentGeneralConditionCard, PrinterIcon, Typography } from "@cpj-ai/panel-npm-package";
import { useGetJobSeekersAssessmentsQuery } from "@graphql/generated";
import { Button, useDisclosure } from "@heroui/react";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { routes } from "@constants/routes";
import AssessmentDetailModal from "./AssessmentDetailModal";
import { AssessmentDetail } from "./types";

const AssessmentsTabContent = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const {
        data,
        loading: assessmentsLoading,
        error: assessmentsError,
        refetch,
        networkStatus,
    } = useGetJobSeekersAssessmentsQuery({
        variables: { id: id ?? "" },
    });

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [selectedAssessment, setSelectedAssessment] = React.useState<AssessmentDetail>(null);

    const rawAssessments = data?.admin?.jobSeekers?.edges?.[0]?.node?.assessments;
    const assessments = rawAssessments?.filter((a): a is NonNullable<typeof a> => a != null) ?? [];

    return (
        <div>
            <div className="mb-6 rounded-2xl border border-primary-100 bg-primary-50/40 px-4 py-4 sm:px-5 sm:py-5">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div className="min-w-0">
                        <Typography className="text-sm sm:text-base font-semibold text-primary-700">
                            Print assessments & general statistics
                        </Typography>
                        <Typography className="text-xs sm:text-sm text-primary-600 mt-1">
                            View a consolidated, print-ready report of this jobseeker&apos;s AI assessments, scores, and
                            detailed answers.
                        </Typography>
                    </div>
                    <Button
                        size="md"
                        color="primary"
                        variant="solid"
                        className="font-semibold text-xs sm:text-sm px-4 sm:px-6"
                        onPress={() => {
                            if (!id) return;
                            navigate(routes.talentPool.assessmentsPrint.replace(":id", id));
                        }}
                    >
                        <PrinterIcon width={20} height={20} className="stroke-white" />
                        Print full assessment report
                    </Button>
                </div>
            </div>

            <AssessmentGeneralConditionCard
                type={"mandatory"}
                assessmentsData={{ me: { assessments } }}
                assessmentsLoading={networkStatus === NetworkStatus.refetch || assessmentsLoading}
            />
            <AIAssessmentsList
                assessmentsData={{ me: { assessments } }}
                assessmentsLoading={assessmentsLoading}
                assessmentsError={assessmentsError}
                onAssessmentEnd={refetch}
                isClickableCard
                handleOpenAssessmentDetailModalInOrg={(data) => {
                    const assessmentDetail = assessments?.find((assessment) => assessment?.id === data.id) ?? null;
                    if (assessmentDetail) {
                        setSelectedAssessment(assessmentDetail);
                        onOpen();
                    }
                }}
            />

            <AssessmentDetailModal isOpen={isOpen} onClose={onClose} assessment={selectedAssessment} />
        </div>
    );
};

export default AssessmentsTabContent;
